import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#05050a] border-t border-white/5 pt-16 pb-8 relative z-10" data-id="element-99">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-101">
          <div className="md:col-span-1" data-id="element-102">
            <a href="#" className="flex items-center gap-2 mb-4" data-id="element-103">
              <div className="bg-gradient-to-br from-blue-500 to-cyan-400 p-1.5 rounded-md" data-id="element-104">
                <TrendingUpIcon className="w-5 h-5 text-white" data-id="element-105" />
              </div>
              <span className="text-lg font-bold tracking-tight text-white" data-id="element-106">
                Scale
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400" data-id="element-107">
                  Finance
                </span>
              </span>
            </a>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-108">
              Data-driven financial strategies for ambitious Australians. Build,
              protect, and scale your wealth with precision.
            </p>
          </div>

          <div data-id="element-109">
            <h4 className="text-white font-semibold mb-4" data-id="element-110">Quick Links</h4>
            <ul className="space-y-2 text-sm text-slate-400" data-id="element-111">
              <li data-id="element-112">
                <a href="#services" className="hover:text-blue-400 transition-colors" data-id="element-113">
                  Services
                </a>
              </li>
              <li data-id="element-114">
                <a href="#tools" className="hover:text-blue-400 transition-colors" data-id="element-115">
                  Interactive Tools
                </a>
              </li>
              <li data-id="element-116">
                <a href="#about" className="hover:text-blue-400 transition-colors" data-id="element-117">
                  About Us
                </a>
              </li>
              <li data-id="element-118">
                <a href="#contact" className="hover:text-blue-400 transition-colors" data-id="element-119">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-120">
            <h4 className="text-white font-semibold mb-4" data-id="element-121">Services</h4>
            <ul className="space-y-2 text-sm text-slate-400" data-id="element-122">
              <li data-id="element-123">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-124">
                  Financial Planning
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-126">
                  Tax Strategy
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-128">
                  Wealth Management
                </a>
              </li>
              <li data-id="element-129">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-130">
                  Business Advisory
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-131">
            <h4 className="text-white font-semibold mb-4" data-id="element-132">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-400" data-id="element-133">
              <li data-id="element-134">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-135">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-136">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-137">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-138">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-139">
                  Financial Services Guide
                </a>
              </li>
              <li data-id="element-140">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-141">
                  Disclaimer
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-142">
          <p className="text-xs text-slate-500 text-center md:text-left" data-id="element-143">
            © {new Date().getFullYear()} Scale Finance Strategies Pty Ltd. All
            rights reserved. <br className="md:hidden" data-id="element-144" />
            AFSL 123456 | ABN 12 345 678 901
          </p>
          <p className="text-xs text-slate-500 max-w-xl text-center md:text-right" data-id="element-145">
            General Advice Warning: The information provided on this website is
            general in nature and does not consider your personal financial
            situation, objectives or needs.
          </p>
        </div>
      </div>
    </footer>;
}